// AuthStore Vector Util

function createAuthStore() {
  let userDetails = {
    userId: null,
    slug: null,
    jwt: null,
  };

  return {
    set: ({ userId, slug, jwt }: { userId?: any, slug?: any, jwt?: any }) => {
      userDetails = {
        userId,
        slug,
        jwt,
      };
    },
    setKey: ({ key, value }: { key: 'userId' | 'slug' | 'jwt', value: any }) => { userDetails[key] = value; },
    get: () => (userDetails),
  };
}

export default createAuthStore();